<template>
  <form action="" style="width: 30rem;">
    <div class="flex flex-col mb-3">
      <label for="" :class="style.form.label">FIRST NAME *</label>
      <input type="text" :class="style.form.input" class="bg-gray-100" v-model="staff.first_name">
    </div>

    <div class="flex flex-col mb-3">
      <label for="" :class="style.form.label">LAST NAME *</label>
      <input type="text" :class="style.form.input" class="bg-gray-100" v-model="staff.last_name">
    </div>

    <div class="flex flex-col mb-3">
      <label for="" :class="style.form.label">EMAIL *</label>
      <input type="text" :class="style.form.input" class="bg-gray-100" v-model="staff.email">
    </div>

    <div class="flex flex-col mb-3">
      <label for="" :class="style.form.label">PHONE *</label>
      <input type="text" :class="style.form.input" class="bg-gray-100" v-model="staff.phone_number">
    </div>

    <!-- <div class="flex flex-col mb-3">
      <label for="" :class="style.form.label">ROLE</label>
      <vue-single-select v-model="selectedRole" :options="roles" placeholder="Select A Role" label="name"></vue-single-select>
    </div> -->

    <!-- BUTTONS -->

    <div v-if="needNavBack" class="flex mt-5">
      <!-- <button type="button" class="w-full text-gray-500 text-sm duration-300 hover:text-blue-700 outline-none">Back</button> -->
      <button type="button" class="w-full" :class="style.btn.fill" @click="saveStaff('create')">
        Save and go back
      </button>
    </div>

    <button v-else-if="staffToEdit" type="button" class="w-full mt-5" :class="style.btn.fill" @click="saveStaff('edit')">Save</button>

    <button v-else type="button" class="w-full mt-5" :class="style.btn.fill" @click="saveStaff('create')">
      Save and email password
    </button>

    <div v-if="errorMessage" class="text-red-700 text-sm">{{errorMessage}}</div>

  </form>
</template>

<script>
  import { mapState } from 'vuex'
  import VueSingleSelect from "vue-single-select"

  export default {
    data() {
      return {
        staff: {
          first_name: null, last_name: null, phone_number: null, email: null, role: null,
        },
        selectedRole: null,
        roles: ['admin', 'staff'],
        style: this.$store.state.style,
        errorMessage: null,
        validations: ['first_name', 'last_name', 'email', 'phone_number']
      }
    },
    components: {
      VueSingleSelect
    },

    computed: {
      ...mapState(['user', 'client'])
    },

    props: {
      needNavBack: { type: Boolean, default: false },
      formType: { type: String, default: 'new' },
      staffToEdit: { type: Object }
    },

    mounted() {
      if (this.staffToEdit) this.staff = {...this.staffToEdit}
    },

    methods: {
      processData(res) {
        console.log(res)
        if (res.status==200) {
          // console.log(res.data.client)
          if (this.needNavBack) {
            this.$emit('navBackWithData', res.data.client)
          } else {
            this.$router.go()
          }
        } else {
          this.errorMessage = "Oops, something went wrong, please try again."
        }
      },

      saveStaff(action) {
        const { id } = this.user
        const has_data = this.validations.every(k => this.staff[k])
        if (has_data) {
          if (action == 'create') {
            this.$ax.post('staff', { customer_staff: this.staff, user: this.user, client: this.client })
              .then(res => {
                this.processData(res)
              })
              .catch(error => {
                this.errorMessage = error.response.data.errors[0]
              })
          } else if (action == 'edit') {
            this.$ax.put('staff/'+ this.staff.id, {user: this.staff})
              .then(res => {
                this.processData(res)
              })
          }
        } else {
          this.errorMessage = "Please input all details and try again. (*)"
        }
      }
    }
  }
</script>

<style>

</style>
